import { Box, Grid, Typography } from '@mui/material'

import { useRef } from 'react'

export const Details = (props) => {
    const { data } = props

    const infoStr = useRef({
        subscription: 'Subscription',
        virtualNetwork: 'Virtual network',
        resourceGroup: 'Resource group'
    })

    const info = useRef(['subscription', 'virtualNetwork', 'resourceGroup'])

    return (
        <Box sx={{padding: '16px'}}>
            <Grid container spacing={3} textAlign={'left'}>
                {info.current.map(item => {
                    const value = (data[item] && (data[item].length > 0))
                        ? data[item] : '-'

                   return (
                       <>
                           <Grid item xs={6} sm={2} textAlign={'left'}>
                               <Typography variant={'h6'}>{infoStr.current[item]}</Typography>
                           </Grid>
                           <Grid item xs={6} sm={10} textAlign={'left'}>
                               {value}
                           </Grid>
                       </>
                   )
                })}
            </Grid>
        </Box>
    )
}

export default Details